import { useLayoutEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { initializeAuthForCurrentRoute } from '../../services/auth/bootstrap'

const AuthScopeSync = () => {
    const location = useLocation()

    useLayoutEffect(() => {
        initializeAuthForCurrentRoute(location.pathname)
    }, [location.pathname])

    return <Outlet />
}

export default AuthScopeSync
